(() => {
  if (customElements.get('tp-pants-measurements')) return;
  const normalize = value => String(value ?? '').trim().toUpperCase();
  customElements.define('tp-pants-measurements', class extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.currentSize = normalize(this.dataset.selectedSize);
      this.onVariantUpdate = event => {
        const detail = event.detail;
        if (String(detail?.data?.productId) !== this.dataset.productId) return;
        if (event.target.closest?.('.shopify-section') !== this.closest('.shopify-section')) return;
        const size = detail?.resource?.options?.[Number(this.dataset.sizeIndex)];
        if (size == null) return;
        this.currentSize = normalize(size);
        this.applySize();
      };
      document.addEventListener('variant-picker:update', this.onVariantUpdate);
      this.observer = new MutationObserver(() => {
        if (this.productId !== this.dataset.productId) {
          this.productId = this.dataset.productId;
          this.currentSize = normalize(this.dataset.selectedSize);
        }
        this.applySize();
      });
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-id', 'data-selected-size', 'data-selected'] });
      this.applySize();
    }
    disconnectedCallback() {
      document.removeEventListener('variant-picker:update', this.onVariantUpdate);
      this.observer?.disconnect();
    }
    applySize() {
      const headers = [...this.querySelectorAll('thead [data-measurement-size]')];
      const header = headers.find(cell => cell.dataset.measurementSize === this.currentSize);
      const chartSize = header?.dataset.chartSize;
      const label = this.querySelector('[data-current-size]');
      const selectedLabel = this.currentSize + (chartSize && normalize(chartSize) !== this.currentSize ? ` (${chartSize})` : '');
      if (label && label.textContent !== selectedLabel) label.textContent = selectedLabel;
      this.querySelectorAll('[data-measurement-size]').forEach(cell => {
        const active = cell.dataset.measurementSize === this.currentSize;
        if (active && cell.dataset.selected !== 'true') cell.dataset.selected = 'true';
        else if (!active && cell.hasAttribute('data-selected')) cell.removeAttribute('data-selected');
        if (cell.closest('thead')) {
          if (active && cell.getAttribute('aria-current') !== 'true') cell.setAttribute('aria-current', 'true');
          else if (!active && cell.hasAttribute('aria-current')) cell.removeAttribute('aria-current');
        }
      });
      this.querySelectorAll('[data-current-measurement]').forEach(summary => {
        const row = this.querySelector(`[data-measurement-index="${summary.dataset.currentMeasurement}"]`);
        const cell = [...(row?.querySelectorAll('td[data-measurement-size]') ?? [])].find(item => item.dataset.measurementSize === this.currentSize);
        const value = cell?.dataset.value ?? '';
        const text = value === '' ? '—' : `${value} ${this.dataset.unit}`;
        if (summary.textContent !== text) summary.textContent = text;
      });
      const hasValues = [...this.querySelectorAll('tbody td[data-value]')].some(cell => cell.dataset.measurementSize === this.currentSize && cell.dataset.value !== '');
      const unavailable = this.querySelector('[data-size-unavailable]');
      if (unavailable && unavailable.hidden !== hasValues) unavailable.hidden = hasValues;
      if (this.dataset.selectedSize !== this.currentSize) this.dataset.selectedSize = this.currentSize;
    }
  });
})();
